import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ActivationEnd, ActivationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { PolicyTokenParamName } from '../../constants';

export const getTokenFromRouteSnapshot = (snapshot: ActivatedRouteSnapshot): string | null => {
  return snapshot.queryParamMap.get(PolicyTokenParamName);
};

const TOKEN_REGEX = new RegExp(PolicyTokenParamName + '=([^&]+)');

@Injectable({
  providedIn: 'root'
})
export class PolicyTokensAccessor {
  private override: string[] = [];
  private tokens$ = new BehaviorSubject<string[]>([]);
  constructor(private router: Router) {
    const match = TOKEN_REGEX.exec(location.search);
    if (match && match[1]) {
      this.tokens$.next([match[1]]);
    }

    this.router.events.subscribe((ev) => {
      if (ev instanceof ActivationEnd || ev instanceof ActivationStart) {
        const token = getTokenFromRouteSnapshot(ev.snapshot);
        if (this.tokens$.value.length !== 1 || token !== this.tokens$.value[0]) {
          this.tokens$.next(token ? [token] : []);
        }
      }
    });
  }

  get(): BehaviorSubject<string[]> {
    const tokensObservable = this.tokens$.asObservable();
    let current;
    if (this.override.length) {
      current = this.override;
      this.override = [];
    } else {
      current = this.tokens$.value;
    }
    const subject = new BehaviorSubject<string[]>(current);
    // subscribing to a behavior observable which will always emit the current
    // value on new subscribe operations. we may have chosen to override the current
    // value, so skip the first emit
    tokensObservable.pipe(skip(1)).subscribe(subject);
    return subject;
  }

  overrideTokensOnce(tokens: string[]) {
    this.override = tokens;
  }
}
